import React from "react"
import { FeaturesSectionHoverEffectsBaServiceBaaas } from "../common/feature-section-hover-effects-ba-service-baaas"
const BasOffers = () => {
  return (
    <div className="section-py">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                            <h2 className="mb-2.5 text-primary" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">What We Offer</h2>
                            <p className="fw-600 mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">Moweb provides a wide range of Business Analysis services to help companies of every size, spanning many various industries.</p>
                        </div>
                    </div>
                    <div className="row relative">         
                        <div className="w-full">
                            <FeaturesSectionHoverEffectsBaServiceBaaas />
                        </div>         
                    </div>
                </div>
            </div>
  )
}

export default BasOffers
